export { createDashboard } from "./dashboard.js";
export { shouldUseInteractiveDashboard } from "./should-use-dashboard.js";
export type { Dashboard, DashboardOptions } from "./dashboard.js";
export { renderDashboardSnapshot } from "./snapshot.js";
export type { SnapshotOptions } from "./snapshot.js";
export type {
  OutputItem,
  OutputItemKind,
  DashboardStats,
  Command,
  DashboardState
} from "./types.js";
export { defaultHints } from "./components/footer.js";
export type { FooterHint } from "./components/footer.js";
